import { loginFlow as loginSaga } from "@mochi/misc/auth/login/redux/sagas";
import { saga as homeScreenSaga } from "../home-screen/redux/saga";
import { saga as registerRoomSaga } from "../register-room/redux/saga";
import { saga as bookingCalendarSaga } from "../booking-calendar/redux/saga";
import { saga as registerOptionSaga } from "../register-option/redux/saga";
import { saga as bookingConfirmSaga } from "../booking-information/redux/saga";
import { saga as rebookOverview } from "../rebook-overview/redux/saga";

export const sagas = [
    loginSaga,
    homeScreenSaga,
    registerRoomSaga,
    bookingCalendarSaga,
    registerOptionSaga,
    bookingConfirmSaga,
    rebookOverview
];
